import { Timestamp } from '@bufbuild/protobuf/wkt';
import moment from 'moment-timezone';

export const convertTimestampToDateWithTimezone = (timestamp: Timestamp | null | undefined, timezone: string): string => {
    if (!timestamp || !timestamp.seconds) return '';

    try {
        const dateMoment = moment(Number(timestamp.seconds) * 1000).tz(timezone);
        const formattedDate = dateMoment.format('YYYY-MM-DD HH:mm:ss Z');
        return formattedDate;
    } catch (error) {
        return '';  
    }
};

export const convertTimestampToDate = (timestamp: Timestamp | null | undefined): string => {
    if (!timestamp || !timestamp.seconds) return ''; 

    try {
        const dateMoment = moment(Number(timestamp.seconds) * 1000);
        const formattedDate = dateMoment.format('YYYY-MM-DD HH:mm:ss Z');
        return formattedDate;
    } catch (error) {
        return '';
    }
};

export const formatTimestampWithRelative = (timestamp: Timestamp | null | undefined, timezone?: string): { absolute: string; relative: string } => {
    if (!timestamp || !timestamp.seconds) return { absolute: '', relative: '' };

    try {
        const timestampMs = Number(timestamp.seconds) * 1000;
        const dateMoment = timezone ? moment(timestampMs).tz(timezone) : moment(timestampMs);
        
        const absolute = dateMoment.format('YYYY-MM-DD HH:mm:ss');
        const relative = moment(timestampMs).fromNow();
        
        return { absolute, relative };
    } catch (error) {
        return { absolute: '', relative: '' };
    }
};
